export default __webpack_public_path__ + "static/media/pizza4sc.8eabda39.jpg";